import Model, { attr } from '@ember-data/model';

export enum AccountIdentityVerificationStatus {
  notStarted = 'not_started',
  created = 'created',
  pending = 'pending',
  completed = 'completed',
  needsReview = 'needs_review',
  approved = 'approved',
  declined = 'declined',
  expired = 'expired',
  failed = 'failed',
}

const IN_PROGRESS_STATUSES = [
  AccountIdentityVerificationStatus.created,
  AccountIdentityVerificationStatus.pending,
];

const PENDING_REVIEW_STATUSES = [
  AccountIdentityVerificationStatus.completed,
  AccountIdentityVerificationStatus.needsReview,
];

export default class AccountIdentityVerificationModel extends Model {
  @attr('string') status!: AccountIdentityVerificationStatus;
  @attr('string') verificationUrl?: string;
  @attr('boolean') owner!: boolean;

  get isNotStarted(): boolean {
    return this.status === AccountIdentityVerificationStatus.notStarted;
  }

  get isInProgress(): boolean {
    return IN_PROGRESS_STATUSES.includes(this.status);
  }

  get isPendingReview(): boolean {
    return PENDING_REVIEW_STATUSES.includes(this.status);
  }

  get isApproved(): boolean {
    return this.status === AccountIdentityVerificationStatus.approved;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'account-identity-verification': AccountIdentityVerificationModel;
  }
}
